var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.seen
    ? _c("transition", { attrs: { name: "fade" } }, [
        _c("div", { staticClass: "popup" }, [
          _c("div", { staticClass: "overlay" }),
          _vm._v(" "),
          _c("div", { staticClass: "popup-box" }, [
            _c("img", {
              staticClass: "popup-close",
              attrs: {
                src:
                  "https://cdngarenanow-a.akamaihd.net/webmain/static/game_service/bind/icon_close.png"
              },
              on: { click: _vm.closed }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "popup-title",
              domProps: { textContent: _vm._s(_vm.title) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "popup-content" }, [_vm._t("content")], 2)
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04692540", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04692540","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GSPopup.vue
// module id = null
// module chunks = 